import { AssertionType } from "domain/assertions";
import { RepaymentOptionType } from "domain/indicativeRepaymentOptions";
import { TreatmentOptionPayloadType } from "domain/menuOptions";
import {
  arrayDecoder,
  boolDecoder,
  Decoder,
  exactDecoder,
  numberDecoder,
  objectDecoder,
  oneOfDecoders,
  stringDecoder,
} from "json-decoder";
import { SelectedTreatmentsPostJson } from "../types/types";
import {
  existingLoanDetailsDecoder,
  repaymentOptionJsonDecoder,
} from "./calculateIndicativeRepaymentOptions";

export type AboutYou = SelectedTreatmentsPostJson.Properties.AboutYou;
export const aboutYouJsonDecoder = objectDecoder<AboutYou>({
  firstName: stringDecoder,
  lastName: stringDecoder,
  email: stringDecoder,
  phoneCode: stringDecoder,
  phoneNumber: stringDecoder,
});
export type AboutLoan = SelectedTreatmentsPostJson.Properties.AboutLoan;
export const aboutLoanJsonDecoder = objectDecoder<AboutLoan>({
  accountNumber: stringDecoder,
  sortCode: stringDecoder,
  remainingBalance: numberDecoder,
  CRHCountTaken: numberDecoder,
  CIRHCountTaken: numberDecoder,
  fullTermExtensionTaken: boolDecoder,
  finalRepaymentDate: stringDecoder,
  CIRHWithTermExtensionCountTaken: numberDecoder,
  CRHWithTermExtensionCountTaken: numberDecoder,
  brand: stringDecoder,
});

export const treatmentOptionTypeDecoder =
  oneOfDecoders<SelectedTreatmentsPostJson.Properties.TreatmentOptionType>(
    exactDecoder(TreatmentOptionPayloadType.EXTEND_TERM),
    exactDecoder(TreatmentOptionPayloadType.REQUEST_PAYMENT_HOLIDAY)
  );

export const selectedOptionTypeDecoder =
  oneOfDecoders<SelectedTreatmentsPostJson.Properties.SelectedOptionType>(
    exactDecoder(RepaymentOptionType.ExtendTerm),
    exactDecoder(RepaymentOptionType.CRHWithoutExtendTerm),
    exactDecoder(RepaymentOptionType.CRHExtendTerm),
    exactDecoder(RepaymentOptionType.CIRHWithoutExtendTerm),
    exactDecoder(RepaymentOptionType.CIRHExtendTerm)
  );
export const attestationKeyDecoder: Decoder<string> = oneOfDecoders(
  exactDecoder(AssertionType.DiscussAlternativeOptions),
  exactDecoder(AssertionType.DiscussFinancialDifficulty),
  exactDecoder(AssertionType.DiscussPAYGOptions)
);
export const attestationInformationJsonDecoder =
  objectDecoder<SelectedTreatmentsPostJson.Properties.AttestationInformation.Items>(
    {
      attestationKey: attestationKeyDecoder,
      attestationValue: boolDecoder,
    }
  );

export const selectedTreatmentsJsonDecoder =
  objectDecoder<SelectedTreatmentsPostJson>({
    aboutYou: aboutYouJsonDecoder,
    aboutLoan: aboutLoanJsonDecoder,
    hardStoppedOnUI: boolDecoder,
    attestationInformation: arrayDecoder(attestationInformationJsonDecoder),
    treatmentOptionType: treatmentOptionTypeDecoder,
    selectedOptionType: selectedOptionTypeDecoder,
    existingLoanDetails: existingLoanDetailsDecoder,
    repaymentOptions: arrayDecoder(repaymentOptionJsonDecoder),
  });
